export default "/images/vendor/flag-icon-css/flags/1x1/my.svg?b59320d866c2aeb135d9b079d52fb4a4";